



































































































































import { mapGetters } from "vuex";
import Breadcrumb from "@/views/layout/components/Breadcrumb/index.vue";
import Hamburger from "@/views/layout/components/Hamburger/index.vue";
import LangSelect from "@/views/layout/components/LangSelect/index.vue";
import { Component, Vue } from "@/common";
import BasePage from '@/views/BasePage';

@Component({
  components: {
    Breadcrumb,
    Hamburger,
    LangSelect
  }
})
export default class Navbar extends BasePage {
  get sidebar() {
    return this.$store.state.app.sidebar;
  }

  get avatar() {
    return require("@/assets/images/avatar.jpg");
  }

  UpdPwdFromVisible = false;
  saveMask = false;
  ChangePasswordForm = {
    OLDPASSWORD: "",
    NEWPASSWORD: "",
    CONFIRMPASSWORD: "",
    SHOW: {
      old: false,
      new: false,
      confirm: false
    }
  };

  rules = {
    OLDPASSWORD: [{ required: true, message: "请输入原密码", trigger: "blur" }],
    NEWPASSWORD: [
      { required: true, message: "请输入新密码", trigger: "blur" },
      { min: 6, message: "密码不能小于6位", trigger: "blur" }
    ],
    CONFIRMPASSWORD: [
      { required: true, message: "请确认新密码", trigger: "blur" },
      { min: 6, message: "密码不能小于6位", trigger: "blur" }
    ]
  };

  ToChangePasswordForm() {
    this.UpdPwdFromVisible = true;
    this.resetForm("CgPwdForm");
    this.ChangePasswordForm.SHOW.old = false;
    this.ChangePasswordForm.SHOW.new = false;
    this.ChangePasswordForm.SHOW.confirm = false;
  }

  SAVE() {
    if (
      this.ChangePasswordForm.NEWPASSWORD !=
      this.ChangePasswordForm.CONFIRMPASSWORD
    ) {
      this.$confirm("新密码和确认密码不一致！", "提示", {
        type: "warning",
        showCancelButton: false
      });
      return;
    }
    if (
      this.ChangePasswordForm.NEWPASSWORD ===
      this.ChangePasswordForm.OLDPASSWORD
    ) {
      this.$confirm("新密码不能与旧密码相同，请重新输入新密码！", "提示", {
        type: "warning",
        showCancelButton: false
      });
      this.ChangePasswordForm.NEWPASSWORD = "";
      this.ChangePasswordForm.CONFIRMPASSWORD = "";
      return;
    }
    this.isFormValid("CgPwdForm", valid => {
      if (valid) {
        this.saveMask = true;
        this.$http
          .post("Home/SaveNewPassword", {
            OLDPASSWORD: this.ChangePasswordForm.OLDPASSWORD,
            NEWPASSWORD: this.ChangePasswordForm.NEWPASSWORD
          })
          .then(res => {
            if (res.data.status === 0) {
              this.saveMask = false;
              this.UpdPwdFromVisible = false;
              // this.$message.success("密码修改成功");
              this.$confirm("密码修改成功!", "提示", {
                type: "info",
                showCancelButton: false
              });
              /* .then(() => {
                  this.logout();
                }) */
              /* .catch(() => {
                  // this.$router.push( path: "/Home" );
                  this.logout();
                }); */
            } else {
              this.saveMask = false;
              this.$message.warning(res.data.msg);
            }
          })
          .catch(err => {
            this.$message.warning(err);
          });
      }
    });
  }

  msgClick() {
    this.$message("没有新消息");
  }

  toggleSideBar() {
    console.log('aa');
    this.$store.dispatch("ToggleSideBar");
  }

  logout() {
    this.$http.post("Home/Logout").then(() => {
      this.$auth.clearToken();
      location.href = "/scm";
    });
  }
}
